import React from 'react';
import { Link } from 'react-router-dom';
import { Package, DollarSign, ClipboardList, Users, Tags } from 'lucide-react';

const Admin: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-4xl font-bold mb-2">Admin Portal</h1>
        <p className="text-gray-600">Manage your products, orders, and pricing settings.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <Link
          to="/admin/products"
          className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow"
        >
          <div className="flex items-center mb-4">
            <Package className="h-8 w-8 text-blue-600 mr-3" />
            <h2 className="text-xl font-semibold">Products</h2>
          </div>
          <p className="text-gray-600">Add, edit, or remove products from your catalog. Configure product-specific materials and finishing options.</p>
        </Link>

        <Link
          to="/admin/orders"
          className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow"
        >
          <div className="flex items-center mb-4">
            <ClipboardList className="h-8 w-8 text-green-600 mr-3" />
            <h2 className="text-xl font-semibold">Orders</h2>
          </div>
          <p className="text-gray-600">Review and process customer orders, update order status, and manage fulfillment.</p>
        </Link>

        <Link
          to="/admin/pricing"
          className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow"
        >
          <div className="flex items-center mb-4">
            <DollarSign className="h-8 w-8 text-yellow-600 mr-3" />
            <h2 className="text-xl font-semibold">Pricing Rules</h2>
          </div>
          <p className="text-gray-600">Set volume discounts and pricing strategies.</p>
        </Link>

        <Link
          to="/admin/users"
          className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow"
        >
          <div className="flex items-center mb-4">
            <Users className="h-8 w-8 text-purple-600 mr-3" />
            <h2 className="text-xl font-semibold">Users</h2>
          </div>
          <p className="text-gray-600">Manage user accounts, roles, and permissions.</p>
        </Link>

        <Link
          to="/admin/categories"
          className="bg-white p-6 rounded-lg shadow-lg hover:shadow-xl transition-shadow"
        >
          <div className="flex items-center mb-4">
            <Tags className="h-8 w-8 text-indigo-600 mr-3" />
            <h2 className="text-xl font-semibold">Categories</h2>
          </div>
          <p className="text-gray-600">Manage product categories and their display images.</p>
        </Link>
      </div>

    </div>
  );
};

export default Admin;